const CPF_LENGTH = 11;

export function formatIdentifierInput(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, CPF_LENGTH);

  if (digits.length > 9) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, '$1.$2.$3-$4');
  }
  if (digits.length > 6) {
    return digits.replace(/(\d{3})(\d{3})(\d{1,3})/, '$1.$2.$3');
  }
  if (digits.length > 3) {
    return digits.replace(/(\d{3})(\d{1,3})/, '$1.$2');
  }
  return digits;
}

export function normalizeIdentifier(value: string): string {
  return value.trim().replace(/\D/g, '');
}
